import { useCallback, useEffect, useState } from "react";
import baseUrl from "../api/baseUrl";

/** WhatsApp / email token alert, same idea as SmsAlertData. */
export type ChannelAlert = {
  channel: "whatsapp" | "email";
  label: string;
  level: "depleted" | "low";
  message: string;
  tokenCredits: number;
  lowBalanceThreshold?: number;
  topUpPath: string;
};

const POLL_MS = 30 * 60 * 1000;

export function useChannelAlerts() {
  const [alerts, setAlerts] = useState<ChannelAlert[]>([]);

  const fetchAlerts = useCallback(async () => {
    try {
      const response = await baseUrl.get("/client/account/channel-alerts");
      setAlerts(response?.data?.success ? (response.data.data as ChannelAlert[]) ?? [] : []);
    } catch {
      setAlerts([]);
    }
  }, []);

  useEffect(() => {
    fetchAlerts();
    const pollId = window.setInterval(fetchAlerts, POLL_MS);
    window.addEventListener("sms-balance-changed", fetchAlerts);
    return () => {
      window.clearInterval(pollId);
      window.removeEventListener("sms-balance-changed", fetchAlerts);
    };
  }, [fetchAlerts]);

  return { alerts, refetch: fetchAlerts };
}
